import React, { useMemo } from 'react';

import {
  MONACO_READONLY_OPTIONS,
  StudioEditorContainer,
  useStudioEditor,
} from 'src/hooks/useStudioEditor';

import { Body } from '../shared';

interface BodyViewerProps extends Body {
  className?: string;
}

export const BodyViewer = ({
  kind,
  content = '',
  className,
}: BodyViewerProps) => {
  const editorDefaultValue = useMemo(() => {
    return typeof content === 'string'
      ? content
      : JSON.stringify(content, null, 2);
  }, [content]);

  const editor = useStudioEditor({
    language: kind === 'json' || typeof content === 'object' ? 'json' : 'text',
    defaultValue: editorDefaultValue,
    ...MONACO_READONLY_OPTIONS,
    showFoldingControls: 'always',
  });

  return <StudioEditorContainer editor={editor} className={className} />;
};
